import script from "./CustomerSpend.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerSpend.vue?vue&type=script&setup=true&lang=js"

import "./CustomerSpend.vue?vue&type=style&index=0&id=594bccc8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-594bccc8"]])

export default __exports__